import { FrxBaseBean } from './frxbasebean';
export class Belezhka extends FrxBaseBean {
	lawsuiteId: number;
	note: string;
}
//test commit Valentino
